import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';

import { styled } from '@material-ui/styles';
import { Switch } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import { openReport } from '../../Utilities/openReport';

import './Help.scss';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,.35)'
        : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export default function Help({ cbFriendly, handleOptionsChange }) {
  const [helpVisible, setHelpVisible] = useState(false);

  const hideHelp = (clicked) => {
    let container = document.getElementById('help-container');
    if (!helpVisible && container !== clicked && !container.contains(clicked)) {
      setHelpVisible(false);
    }
  };

  const handleClick = () => {
    document.getElementById('grid').addEventListener('click', function (event) {
      hideHelp(event.target);
    });

    ReactGA.event('click_help_icon');
    setHelpVisible(!helpVisible);
  };

  const handleSelect = (choice) => {
    ReactGA.event('click_help_option', {
      help_selection: choice,
    });

    if (choice === 'report') {
      openReport();
    } else {
      setHelpVisible(!helpVisible);
      handleOptionsChange(choice, 'infoModal');
    }
  };

  return (
    <div
      id='help-container'
      className={`card ${!helpVisible ? 'help-hidden' : ''}`}
    >
      <div id='help-icon' onClick={handleClick}>
        {helpVisible ? <CloseIcon /> : <HelpOutlineIcon />}
      </div>
      <div id='help-options'>
        <ul>
          <li onClick={() => handleSelect('purposeOfTool')}>
            Purpose of the Tool
          </li>
          <li onClick={() => handleSelect('howToUseTool')}>
            How to Use the Tool
          </li>
          <li onClick={() => handleSelect('dataAndTech')}>
            Data and Technical Information
          </li>
          <li onClick={() => handleSelect('report')}>See the Report</li>
        </ul>

        <div id='add-pattern'>
          <div id='add-pattern-text'>Use alternate precipitation coloring</div>
          <AntSwitch
            color='primary'
            size='small'
            checked={cbFriendly}
            onChange={(e) =>
              handleOptionsChange(e.target.checked, 'cbFriendly')
            }
          />
        </div>
      </div>
    </div>
  );
}

Help.propTypes = {
  cbFriendly: PropTypes.bool,
  handleOptionsChange: PropTypes.func,
};
